import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { Z_INDEX } from '../../foundations/zIndex';
export const commonIconStyles = (FOUNDATIONS) => {
    return {
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
        color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
    };
};
export const arrowIconContainerCommonStyles = (FOUNDATIONS) => {
    return {
        display: 'none',
        align_items: 'center',
        justify_content: 'center',
        z_index: Z_INDEX.INTERN_2,
        cursor: 'pointer',
        background_color: FOUNDATIONS.color_exception_neutral_bg_1350,
        [DeviceBreakpointsType.MOBILE]: {
            display: 'flex',
        },
    };
};
//# sourceMappingURL=commonStyles.js.map